import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import axios from "axios";

const UserCustomerLogin = () => {
    const [logging, setLogging] = useState(false);

    const currentYear = new Date().getFullYear();

    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        email: "",
        password: "",
        position: "user_customer",
    });

    const { email, password } = formData;
    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const login = () => {
        if (emailPattern.test(email)) {
            setLogging(true);
            axios.post(`${APIURL}/api/v1/users/login`, formData, {
                headers: {
                    "Content-Type": "application/json",
                }
            },)
                .then(response => {
                    if (response.status) {
                        localStorage.setItem('customer_token', response?.data?.token)
                        localStorage.setItem('customer_id', response?.data?.id)
                        navigate("/customer-profile")
                    }
                })
                .catch(error => {
                    toast.error(error?.response?.data?.message)
                }).finally(() => setLogging(false));
        }
    }


    return (
        <React.Fragment>
            <ToastContainer autoClose={2000} />
            <div className="d-flex flex-column flex-root">
                <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                    <div className="d-flex flex-column flex-lg-row-fluid py-10">
                        <div className="d-flex flex-center flex-column flex-column-fluid">
                            <div className="w-lg-500px p-10 p-lg-15 mx-auto w-100">
                                <form className="form w-100" noValidate="noValidate">
                                    <div className="text-center mb-10">
                                        <h1 className="text-dark mb-3">Log In</h1>
                                    </div>
                                    <div className="fv-row mb-10">
                                        <label className="form-label fs-6 fw-bolder text-dark">
                                            <span className="required">Email</span>
                                        </label>
                                        <input
                                            className="form-control form-control-lg form-control-solid"
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={(e) => onChange(e)}
                                        />
                                        {email && !emailPattern.test(email) && (
                                            <p style={{ color: 'red' }}>Please enter a valid email address</p>
                                        )}
                                    </div>
                                    <div className="fv-row mb-10">
                                        <div className="d-flex flex-stack mb-2">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0">
                                                <span className="required">Password</span>
                                            </label>
                                        </div>
                                        <input
                                            className="form-control form-control-lg form-control-solid"
                                            type="password"
                                            name="password"
                                            value={password}
                                            onChange={(e) => onChange(e)}
                                        />
                                    </div>
                                    <div className="text-center">
                                        <button
                                            onClick={login}
                                            className={`btn btn-lg btn-primary w-100 position-relative mb-5 ${email == "" || password == "" && "disabled"
                                                }`}
                                            type="button"
                                        >
                                            {logging ? (
                                                <div>
                                                    <span className="text-transparent">Loading...</span>
                                                    <div className="position-absolute top-50 start-50 translate-middle">
                                                        <div className="spinner-border w-80" role="status">
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <span className="indicator-label">Continue</span>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
                            <div className="d-flex flex-center fw-bold fs-6">
                                <p>{currentYear} © Copyright All rights reserved.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default UserCustomerLogin;
